module.exports = __webpack_public_path__ + "static/media/hamamo_top_logo.d0b6f7e7.png";